module.exports = __webpack_public_path__ + "static/media/Q_2_12.39247916.jpg";